export default __webpack_public_path__ + "static/media/4636.bf3341cf.png";